export default "__VITE_ASSET__CvFOvFxs__"